import axios from 'axios';
import {API_IP} from "../consts/api";

export default async function () {
  try {

    let resp = await axios.get(API_IP);

    return resp.data

  } catch (e) { throw e }
}
